import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { ArrowRight, Loader2, KeyRound } from "lucide-react";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) {
      toast.error("Le due password non coincidono");
      return;
    }
    setSubmitting(true);
    try {
      const { data: user } = await api.post("/auth/reset-password", { token, new_password: pwd });
      await refresh();
      toast.success("Password aggiornata con successo");
      navigate(user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8F9] p-6" data-testid="reset-password-page">
      <div className="w-full max-w-md fade-up">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#0F7B85]">
          ← Torna al login
        </Link>
        <div className="mt-6 bg-white border border-slate-200 rounded-2xl p-8 sm:p-10">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-[#F39C12]/10 flex items-center justify-center">
              <KeyRound className="w-7 h-7 text-[#F39C12]" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-slate-500">Nuova password</div>
              <h1 className="font-display text-xl text-[#0F7B85] mt-0.5">Imposta una nuova password</h1>
            </div>
          </div>

          <p className="mt-5 text-sm text-slate-600 leading-relaxed">
            Scegli una password sicura: almeno <strong>8 caratteri</strong>, una lettera e un numero.
          </p>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-password-form">
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Nuova password</label>
              <input
                type="password" required minLength={8} value={pwd} onChange={(e) => setPwd(e.target.value)}
                data-testid="reset-password-input"
                placeholder="Almeno 8 caratteri"
                className="w-full bg-white border border-slate-200 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#0F7B85] focus:border-transparent outline-none transition-all"
              />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Conferma password</label>
              <input
                type="password" required minLength={8} value={pwd2} onChange={(e) => setPwd2(e.target.value)}
                data-testid="reset-password-confirm-input"
                placeholder="Ripeti la nuova password"
                className="w-full bg-white border border-slate-200 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#0F7B85] focus:border-transparent outline-none transition-all"
              />
            </div>
            <button
              type="submit" disabled={submitting} data-testid="reset-password-submit-button"
              className="w-full bg-[#0F7B85] text-white hover:bg-[#0A5C64] disabled:opacity-60 rounded-lg px-6 py-3 font-medium transition-colors inline-flex items-center justify-center gap-2"
            >
              {submitting ? <Loader2 className="w-4 h-4 animate-spin"/> : <ArrowRight className="w-4 h-4" />}
              Salva e accedi
            </button>
          </form>

          <p className="mt-5 text-xs text-center text-slate-500">
            Per sicurezza, il link può essere utilizzato una sola volta e scade dopo 60 minuti.
          </p>
        </div>
      </div>
    </div>
  );
}
